// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: left;
  padding: 10px;
  font-family: Arial, sans-serif;
  max-width: 650px;
  margin: 0 auto;
}

.App h1 {
  color: #333;
  margin-bottom: 15px;
  text-align: center;
  font-size: 24px;
}

.download-btn {
  background-color: #4CAF50;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  margin-bottom: 20px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.download-btn:hover {
  background-color: #45a049;
}
.run-scheduler-container-left{
  display: flex;
  justify-content: start;
  align-items: center;

}
.run-scheduler-container-right{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.save-btn {
  background-color: #2196F3;
  color: white;
  height:100%;
  padding: 8px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
}

.save-btn:hover {
  background-color: #454ca0;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}


.run-scheduler-btn {
  background-color: #2196F3;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
    
 
 
}

.run-scheduler-btn:hover {
  background-color: #454ca0;
  transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.mandatory-indicator {
  color: red;
  margin-left: 4px;
}

.json-container {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  overflow-x: auto;
}

.json-object {
  border-left: 2px solid #2196F3;
  padding: 10px;
  margin: 8px 0;
  background-color: #f8f9fa;
  border-radius: 3px;
}

.json-key {
  font-weight: bold;
  color: #2196F3;
  margin-bottom: 8px;
  font-size: 14px;
}

.main-heading {
  font-size: 18px;
  margin-bottom: 15px;
  text-align: center;
  color: #333;
}

.json-value {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.json-value label {
  min-width: 120px;
  font-weight: 500;
  color: #555;
  margin-right: 8px;
  font-size: 13px;
}

.json-value input {
  flex: 1 1;
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 13px;
  min-width: 150px;
  max-width: 250px;
}

.json-value input:only-child {
  max-width: none;
  width: 100%;
}

.json-value input:focus {
  outline: none;
  border-color: #2196F3;
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);
}

.json-array {
  margin: 10px 0;
}

.json-array .json-key {
  margin-bottom: 8px;
}

.json-array ul {
  list-style-type: none;
  padding-left: 0;
}

.json-array li {
  margin-bottom: 10px;
  padding: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  background-color: #fff;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.json-array li:hover {
  background-color: #f5f5f5;
}

.array-item-content {
  width: 100%;
  margin-bottom: 5px;
}

.add-btn, .remove-btn {
  background-color: #2196F3;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 11px;
  margin-left: 5px;
  transition: background-color 0.2s;
  align-self: flex-end;
}

.add-btn:hover, .remove-btn:hover {
  background-color: #0b7dda;
}

.remove-btn {
  background-color: #f44336;
}

.remove-btn:hover {
  background-color: #d32f2f;
}

.object-field {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.custom-layout{
  align-items: flex-start !important;
}

.object-field .field-name {
  min-width: 120px;
  font-weight: 500;
  color: #555;
  margin-right: 8px;
  font-size: 13px;
}

.object-field .json-value {
  flex: 1 1;
  margin-left: 0;
  margin-bottom: 0;
  min-width: 200px;
}

.field-name-Inclusion{
min-width: 120px;
     font-weight: 600;
    color: #444;
  margin-right: 8px;
  font-size: 13px;
}

.inclusions-section{
  width: 97.5%;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px;
  margin-left: -5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.field-name-exclusion{
  min-width: 120px;
    font-weight: 600;
    color: #444;
  margin-right: 5px;
  font-size: 15px;
  margin-left: 5px;
}
.nested-content {
  margin-left: 0;
  border-left: none;
  padding-left: 0;
}

.section-box {
  border: 1px solid #ccc;
  border-radius: 6px;
  margin-bottom: 20px;
  background-color: #f9f9f9;
}

.section-header {
  background-color: #e9ecef;
  padding: 10px 15px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 6px 6px 0 0;
  font-weight: 700;
  font-size: 1.1em;
  color: #222;
}

.section-header h3 {
  margin: 0;
  font-size: 1.2em;
}

.collapse-icon {
  font-weight: bold;
  font-size: 1.5em;
  line-height: 1;
}

.section-content {
  padding: 15px;
  
}

.object-field {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

.primitive-field label.field-name {
  width: 120px;
  font-weight: 600;
  color: #444;
}

.primitive-field label.field-name-practiceRouting {
 width: 120px;
  font-weight: 600;   /* slightly bold like other labels */
  font-size: 13px;    /* decrease font size */
  color: #444;
  margin-top: 10px;
}

.primitive-field input {
  flex: 1 1;
  padding: 6px 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-weight: normal;
  color: #333;
  background-color: #fff;
}

/* Reduce border color for time picker selects */
select.mr5,
select.mr10,
select.flex-grow-mr10 {
  border-color: #c5c4c4;
}

.primitive-field input:hover {
  background-color: #f0f0f0;
}

.primitive-field input.tooltip {
  position: relative;
  cursor: help;
}

.primitive-field input.tooltip::after {
  content: "Enter the absentee rate percentage amount ( 0 to 100 )";
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #555;
  color: white;
  padding: 5px 8px;
  border-radius: 6px;
  white-space: nowrap;
  font-size: 12px;
  opacity: 0;
  visibility: hidden;
  z-index: 1000;
  pointer-events: none;
  box-shadow: 0 0 6px rgba(0,0,0,0.3);
  transition: opacity 0.3s, visibility 0.3s;
}

.primitive-field input.tooltip:hover::after {
  opacity: 1;
  visibility: visible;
}

.array-field {
  margin-bottom: 15px;
}

.array-field h5 {
  margin-bottom: 8px;
  font-weight: 700;
  color: #333;
}

.array-item {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.array-item input {
  flex: 1 1;
  padding: 6px 10px;
  font-size: 1em;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.remove-btn {
  margin-left: 10px;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9em;
}

.remove-btn:hover {
  background-color: #c82333;
}

.add-btn {
  margin-left: 8px;
  background-color: #007bff;
  border: none;
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9em;
  vertical-align: middle;
  display: inline-flex;
  align-items: center;
  height: 32px;
}

.add-btn:hover {
  background-color: #0069d9;
}

.appointment-slots-container {
  display: flex;
  gap: 10px;
}

.appointment-slot-box {
  flex: 1 1;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 10px 15px;
  background-color: white;
  width: 70%;
  margin-left: -10px;
  box-sizing: border-box;
}

.weekDay-slot-box {
    flex: 1 1;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 10px 10px;
    width: 175px;
    margin-left: -6px;
    background-color: white;
    
}

.weekDay-slot-box h5{
 margin-top: 2px;
  overflow-x: hidden;
    font-weight: 700;
    color: #222;
}

.appointment-slot-box h5 {
  margin-top: 0;
  margin-bottom: 10px;
  font-weight: 700;
  color: #222;
}

.slot-coverage-explanation {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
  font-style: italic;
}

.daily-slot-item {
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.2s ease;
}

.daily-slot-item:hover {
  background-color: #f0f0f0;
}

.daily-slot-item:last-child {
  margin-bottom: 0;
}

.daily-slot-item-custom {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 8px;
  display: flex;
  gap: 30px;
  align-items: center;
  transition: background-color 0.2s ease;
  max-width: fit-content;
}

.daily-slot-item-custom:hover {
  background-color: #f0f0f0;
}

.daily-slot-item-custom:last-child {
  margin-bottom: 0;
}

.weekly-slots-editor {
  margin-bottom: 15px;
  width: 100%;
  box-sizing: border-box;
}



.weekly-slot-item {
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.2s ease;
}

.weekly-slot-item:hover {
  background-color: #f0f0f0;
}

.weekly-slot-item:last-child {
  margin-bottom: 0;
}

.weekly-slots-list {
  margin-top: 12px;
}

.weekly-slots-list h6 {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

/* Moved from JsonRenderer.js inline styles */
.flex-center-mb6 {
  align-items: center;
  margin-bottom: 6px;
}

.flex-grow-mr10 {
  flex-grow: 1;
  margin-right: 10px;
}

.width80-mr10 {
    
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    box-sizing: border-box;
    width: 74px;
    margin-right: 10px;
    text-align: center;
}

.width80-mr10:hover {
  padding: 8px 12px;
  background-color: #f0f0f0
}

.btn-green {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  
}

.btn-green-courseMin {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 8px;
}

.btn-green:hover {
  background-color: #388a4b;
  color: #d4edda;
}

.flex-center-mb10 {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.mb10{
  border: 1px solid #e0e0e0;
    padding: 6px 12px;
    border-radius: 4px;
    max-width: 532px;
    margin-top: 16px;
    display: inline-block;
    vertical-align: middle;
    width: 180%;
    box-sizing: border-box;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}


.pre-inherit {
  font-family: inherit;
  font-size: inherit;
  margin: 0;
}

.mr10 {
  margin-right: 10px;
}

.ul-none {
  list-style-type: none;
  padding-left: 0;
}

.btn-red {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
}

.btn-red:hover {
  background-color: #c82333;
   color : #f8d7da;
}

.btn-red-custome-remove {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 46px;
}

.btn-red-1 {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  margin: 12px;
}

.btn-red-1:hover{
   background-color: #c82333;
   color : #f8d7da;
}

.flex-center {
  display: flex;
  align-items: center;
}

.flex-center-WH {
  display: flex;
  align-items: center;
        flex: 1 1;
    padding: 6px 10px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-weight: normal;
    color: #333;
    background-color: #fff;
    gap: 5px;
}

.flex-center-WH:hover {
   background-color: #f0f0f0;

}
.flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}
.flex-end-custom {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 33%;
}

.flex-start {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.flex-start-custom {
  display: flex;
  align-items: left ;
  width: 50%;
}


.capitalize {
  text-transform: capitalize;
}

.mt20 {
  margin-top: 20px;
}

.mr5 {
  margin-right: 5px;
}

/* Additional styles moved from JsonRenderer.js */
.state-label {
  width: 120px;
  margin-right: 10px;
  text-transform: capitalize;
  line-height: 24px;
}

.field-select {
  flex-grow: 1;
  min-width: 120px;
  padding: 6px 8px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ccc;
  outline: none;
  cursor: pointer;
  height: 32px;
  font-weight: normal;
  color: #333;
  background-color: #fff;
}

.field-select:hover {
  background-color: #f0f0f0;
}

.field-label-block {
  font-weight: 600;
  margin-bottom: 8px;
  display: block;
}

/* Courses minimum table layout: left sticky course column and scrollable months */
.courses-min-table-wrapper {
  width: 100%;
  overflow: auto; /* allow horizontal scroll for months while keeping course col visible */
  -webkit-overflow-scrolling: touch;
}

.courses-min-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed; /* predictable column widths and wrapping */
}

.courses-min-table th,
.courses-min-table td {
  padding: 8px 10px;
  border-bottom: 1px solid #eee;
  vertical-align: middle;
  text-align: left;
  background-clip: padding-box;
}

.courses-min-table .course-col,
.courses-min-table .course-name-cell {
  width: 240px; /* fixed sidebar width */
  min-width: 200px;
  max-width: 260px;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  text-align: left;
  padding-left: 12px;
}

/* Sticky left column */
.courses-min-table .course-col {
  position: sticky;
  left: 0;
  top: 0; /* keeps header visible */
  z-index: 8;
  background: #e9ecef;
}
.courses-min-table .course-name-cell {
  position: sticky;
  left: 0;
  z-index: 4;
  background: #fff;
}

/* Sticky month header */
.courses-min-table thead th {
  position: sticky;
  top: 0;
  background: #e9ecef;
  z-index: 6;
}

/* Intersection cell (top-left) higher than both */
.courses-min-table thead th.course-col {
  z-index: 10;
}

.courses-min-table td input {
  box-sizing: border-box;
  width: 56px;
  max-width: 100%;
  padding: 6px 8px;
  text-align: center;
}

@media (max-width: 720px) {
  .courses-min-table .course-col,
  .courses-min-table .course-name-cell {
    width: 55%;
  }
}

.mb16 {
  margin-bottom: 16px;
}

.license-input {
  flex-grow: 1;
  padding: 6px 8px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ccc;
  text-transform: uppercase;
  background-color: #fff;
}

.license-input:hover {
  background-color: #f0f0f0;
}

.license-text {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 14px;
  color: #333;
}

.btn-remove {
  margin-left: 8px;
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
}

.btn-remove:hover{
  padding: 6px 12px;
   background-color: #d32f2f;
  color: #f8d7da;
}

.btn-add {
  margin-left: 8px;
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
}

.btn-add-practiceRouting {
  margin-left: auto;
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
}

.btn-add:hover {
   background-color: #388a4b;
    color: #d4edda;
}

.btn-blue {
  margin-left: 8px;
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
}

.btn-blue:hover {
   padding: 6px 12px;
    background-color: #388a4b;
    color: #d4edda;
}


.add-select {
  width: 165px;
  padding: 6px 8px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background-color: #fff;
}

.add-select:hover {
  background-color: #f0f0f0;
}

.add-select-course {
  width: 600px;
  padding: 6px 8px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background-color: #fff;
}

.add-select-course:hover {
  background-color: #f0f0f0;
}
.section-content.collapsed {
  display: none;
}

.section-content.expanded {
  display: block;
}

.box-container {
  margin-bottom: 20px;
}

/* Tooltip styles */
.tooltip {
  position: relative;
  display: inline-block;
  cursor: help;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 260px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 8px;
  position: absolute;
  z-index: 1;
  bottom: 125%; /* Position above the element */
  left: 50%;
  margin-left: -130px;
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 12px;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

/* Fix for courses list to display vertically with box model */
.courses-list > div {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  margin-bottom: 8px !important;
  width: 100% !important;
}

.courses-list > div > div {
  display: flex !important;
  justify-content: flex-start !important;
  align-items: center !important;
  margin-bottom: 8px !important;
  border: 1px solid #ccc !important;
  padding: 6px 12px !important;
  border-radius: 4px !important;
  width: 100% !important;
  gap: 8px !important;
  flex-wrap: nowrap !important;
}

.courses-list > div > div > .course-item {
  margin-left: auto !important;
  max-width: 150px !important;
  box-sizing: border-box !important;
}

.courses-list.box-container {
  border: 1px solid #ccc;
  padding: 6px 12px;
  border-radius: 4px;
  max-width: 320px;
  margin-bottom: 16px;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  box-sizing: border-box;
}

.course-item {
  width: 100%;
  box-sizing: border-box;
}

.btn-remove {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  padding: 2px 8px;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  height: 22px;
  vertical-align: middle;
  margin-left: 8px;
}

/* New styles for updated courses rendering */
.courses-container {
  width: 95%;
  margin-top: 8px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.course-items {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}

.course-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  width: 100%;
  box-sizing: border-box;
}

.course-item:hover{
      padding: 8px 12px;
       background-color:#f0f0f0

}

.course-item span {
  flex-grow: 1;
  font-size: 14px;
  color: #333;
  overflow-wrap: break-word;
}

.course-item button {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 12px;
  height: 24px;
  min-width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.course-item button:hover {
  background-color: #c82333;
}

.existing-items {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 10px;
}

.license-item {
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  border: 1px solid #ccc;
    box-sizing: border-box;
}

.license-item:hover{
  padding: 4px 8px;
   background-color: #f0f0f0;
} 


.license-item .license-text {
  font-weight: normal;
  color: #333;
}

.remove-provider-btn{
  margin-top: 14px;
}


.license-item .btn-remove {
  margin-left: 0;
  padding: 2px 6px;
  font-size: 16px;
  line-height: 1;
  height: auto;
  min-width: auto;
}

.primitive-field .field-value {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.license-value-area {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1 1;
  min-width: 0;
  border: 1px solid #e0e0e0;
  padding: 6px 12px;
  border-radius: 4px;
  max-width: 532px;
  display: flex;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.practiceRouting-value-area {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1 1;
  min-width: 0;
  border: 1px solid #e0e0e0;
  padding: 6px 12px;
  border-radius: 4px;
  max-width: 532px;
  display: flex;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 10px;
}

.add-section-box {
  border: 1px solid #ccc;
  padding: 8px 12px;
  border-radius: 4px;
  background-color: #fff;
  box-sizing: border-box;
}

.license-value-column {
  flex-direction: column !important;
  gap: 10px;
}

.existing-items-license {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  justify-items: start;
  width: 100%;
  margin-bottom: 0;
}

.add-section.flex-center {
  margin-left: auto;
  margin-bottom: 0;
}

.add-section.flex-start {
   justify-content: flex-start ;
   padding-left: 0px ;
   margin-left: 0 ;
}

.add-section-credential {
   justify-content: flex-start;
   align-items: center;
   gap: 5px;
   margin-top: -10px;
}

/* History section styles */
.history-section {
  margin-top: 30px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background-color: #f9f9f9;
}

.history-section .section-header {
  background-color: #e9ecef;
  padding: 10px 15px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 6px 6px 0 0;
  font-weight: 700;
  font-size: 1.1em;
  color: #222;
}

.history-section .section-header h2 {
  margin: 0;
  font-size: 1.2em;
}

.history-section .collapse-icon {
  font-weight: bold;
  font-size: 1.5em;
  line-height: 1;
}

.history-content {
  padding: 15px;
  max-height: 400px;
  overflow-y: auto;
}

.history-item {
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #fff;
}

.history-item p {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #666;
}

.history-item pre {
  background-color: #f8f8f8;
  padding: 10px;
  border-radius: 4px;
  font-size: 12px;
  overflow-x: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.output-files-section {
    background-color: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    overflow-x: auto;
    margin-top: 20px;
}


.output-files-section h2 {
  margin-top: 0;
  font-size: 20px;
  color: #222;
  margin-bottom: 15px;
}

.output-files-section ul {
  list-style-type: none;
  padding-left: 0;
}

.output-files-section li {

}

.output-files-section a {
  color: #2196F3;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
}

.output-files-section a:hover {
  text-decoration: underline;
}

.output-files-section .section-header h2 {
  margin: 0;
  font-size: 1.2em;
}

.output-files-section li {
  cursor: pointer;
}
.link-btn {
  background: none;
  border: none;
  color: #2196F3;
  text-decoration: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  padding: 0;
  font-family: inherit;
}

.link-btn:hover {
  text-decoration: underline;
}

.action-buttons {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}


.changed-field {
  background-color: transparent;
  border-color: inherit;
}

.field-value-display {
  font-size: 14px;
  font-weight: normal;
  color: #333;
  margin-left: 8px;
}

.field-value-display strong {
  font-weight: bold;
}

/* DatePicker styling */
.react-datepicker-wrapper {
  flex: 1 1;
  display: inline-block;
}

.react-datepicker__input-container input {
  width: 100%;
  padding: 6px 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-weight: normal;
  color: #333;
  background-color: #fff;
  box-sizing: border-box;
}

.react-datepicker__input-container-exclusion {
   width: 100%;
  padding: 6px 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-weight: normal;
  color: #333;
  background-color: #fff;
  box-sizing: border-box;
.react-datepicker {
  font-size: 14px;
}
}

.react-datepicker__header {
  background-color: #f0f0f0;
}

.react-datepicker__day--selected {
  background-color: #007bff;
  color: white;
}

/* Specific styling for DatePicker in exclusions section */
.exclusions-section .react-datepicker-wrapper {
  width: 90%;
}

.exclusions-section .react-datepicker__input-container input {
  width: 95%;
}

.availability-editor .weekday-inclusions .flex-center-mb6 span {
  font-weight: normal;
  color: #333;
}
.weekday-inclusions{
  width: 90%;
  margin-top: 10px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 15px;

  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.weekday-inclusions h4 {
  margin-top: -10px;
  margin-bottom: -10px;
  padding: 8px 12px;
  background-color: #fff;

}

.working-hours-edit {
  display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: -20px;
    margin-left: 115px;
}

.courses-display {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
}

.course-display {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 3px;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: normal;
  color: #333;
}

.course-display:hover{
   padding: 8px 12px;
   background-color: #f0f0f0

}

.notification {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 15px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 300px;
  max-width: 500px;
  font-family: Arial, sans-serif;
  font-size: 14px;
}

.notification.success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.notification.error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.notification-close {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: inherit;
  margin-left: 10px;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notification-close:hover {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
}

/* Scheduler error notification styles */
.notification.error span a {
  color: #007bff !important;
  text-decoration: underline !important;
  margin-left: 5px !important;
}

.notification.error span a:hover {
  color: #0056b3 !important;
  text-decoration: none !important;
}

.month-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.month-dialog {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-width: 400px;
  width: 90%;
  font-family: Arial, sans-serif;
}

.month-dialog h3 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #333;
  font-size: 18px;
}

.month-dialog select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  margin-bottom: 20px;
}

.month-dialog select:focus {
  outline: none;
  border-color: #2196F3;
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);
}

.dialog-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.dialog-buttons button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}

.dialog-buttons button:first-child {
  background-color: #2196F3;
  color: white;
}

.dialog-buttons button:first-child:hover {
  background-color: #0b7dda;
}

.dialog-buttons button:last-child {
  background-color: #6c757d;
  color: white;
}

.dialog-buttons button:last-child:hover {
  background-color: #5a6268;
}

.select-course-name{

    justify-content: space-between;
    align-items: center;
    border-radius: 4px;
    background-color: #fff;
    box-sizing: border-box;
   padding: 8px 12px;
   width: 71.7%;
   border: 1px solid #ccc;
}

.day-select {
  width: 120px;
  padding: 6px 8px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background-color: #fff;
  outline: none;
  cursor: pointer;
}


.day-select:hover{
  padding: 6px 8px;
   background-color: #f0f0f0;

}
.select-course-name:hover{
  padding: 8px 12px;
  background-color: #f0f0f0;
}

.courses-min-editor{
  border: 1px solid #e0e0e0;
  padding: 6px 12px;
  border-radius: 4px;
  max-width: 100%;
  margin-bottom: 16px;
  display: block;
  vertical-align: middle;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.courses-min-table-wrapper{
  margin-top: 8px;
}
.courses-min-table-scroll{
  overflow-x: auto;
}
.courses-min-table{
  border-collapse: collapse;
  width: 100%;
  font-size: 14px;
  table-layout: fixed;
}
.courses-min-table th{
  text-align: left;
  font-size: 14px;
  font-weight: 600; /* match practice label weight */
  padding: 8px 10px;
  color: #444;
  background: #e9ecef;
}
.courses-min-table td{
  padding: 8px 10px;
}
.courses-min-table .course-name-cell{
  font-weight: 600; /* match practice label weight */
  white-space: normal;
  padding-right: 14px;
  color: #444;
  overflow-wrap: anywhere;
}
.courses-min-table input{
  width: 56px;
  font-size: 14px; /* align with practice inputs */
  font-weight: normal;
  text-align: center;
  padding: 6px 8px;
}
/* Footer styles */
.footer {
  text-align: center;
  padding: 20px 0;
  font-family: Arial, sans-serif;
  font-size: 0.9rem;
  border-top: 1px solid #d8d8d8;
  margin-top: 40px;
}

.footer-content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
}

.footer-logo {
  height: 30px;
}

.copyright {
  margin: 0;
  color: #333;
}

/* File Groups Styles */
.file-groups {
  margin-top: 10px;
}

.file-group {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  margin-bottom: 15px;
  background-color: #fafafa;
}

.file-group-header {
  padding: 12px 15px;
  background-color: #f0f0f0;
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 6px 6px 0 0;
}

.file-group-header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
  font-weight: 600;
}

.file-group-content {
  padding: 15px;
}

.file-group-content.collapsed {
  display: none;
}

.file-group-content.expanded {
  display: block;
}

.file-group-content ul {
  list-style-type: none;
  padding-left: 0;
  margin: 0;
}

.file-group-content li {
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.file-group-content li:last-child {
  border-bottom: none;
}

.file-group-content a {
  color: #2196f3;
  text-decoration: none;
  font-weight: 500;
}

.file-group-content a:hover {
  text-decoration: underline;
}

/* Navbar styles */
.navbar {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0.5rem 2rem;
 
}

.logo-box {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.logo-img {
  height: 40px;
}

.best-text {
  font-weight: 700;
  font-size: '1.5rem';
  color: '#0e2a71';
}

.title {
  justify-self: center;
  font-weight: 700;
  font-size: 1.8rem;
  color: #0e2a71;
}

.actions {
  justify-self: end;
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* Fixed button styles with EXACT consistent sizing */
.button-base {
  padding: 0.5rem 1rem;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  min-width: 80px;
  text-align: center;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  box-sizing: border-box;
  line-height: 1;
}

.profile-btn {
  background: transparent;
  color: #0e2a71;
  border: 1px solid #0e2a71;
}

.profile-btn:hover {
  background-color: #f0f0f0;
}

.logout-btn {
  background: #0e2a71;
  color: white;
  border: 1px solid #0e2a71;
}

.logout-btn:hover {
  background-color: #454ca0;
}

.dropdown-container {
  position: relative;
}

.dropdown-content {
  display: none;
  position: absolute;
  right: 0;
  top: 45px;
  background-color: white;
  min-width: 250px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.1);
  z-index: 1;
  border-radius: 5px;
  border: 1px solid #eee;
  padding: 12px 16px;
}
    max-width: 100%;
.dropdown-content.show {
  display: block;
}
    box-sizing: border-box;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
.info-p {
  margin: 5px 0;
  font-size: 14px;
}

.dropdown-hr {
  border: 0;
  border-top: 1px solid #eee;
  margin: 8px 0;
}

.roles-p {
  margin: 5px 0;
  font-size: 14px;
  text-transform: capitalize;
}

.scheduler-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
}
`, "",{"version":3,"sources":["webpack://./src/app.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;AAErB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,sCAAsC;AACxC;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;;;;AAIjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;IACzB,yCAAyC;AAC7C;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;AACA,gBAAgB;KACX,gBAAgB;IACjB,WAAW;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;IACd,gBAAgB;IAChB,WAAW;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;;AAEf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;CACC,YAAY;EACX,gBAAgB,IAAI,oCAAoC;EACxD,eAAe,KAAK,uBAAuB;EAC3C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iEAAiE;EACjE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;;AAE3B;;AAEA;CACC,eAAe;EACd,kBAAkB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;;;AAIA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,6CAA6C;AAC7C;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;IAEI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;;AAEjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;IACtB,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,wCAAwC;AAC5C;;;AAGA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;GACxB,eAAe;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;GACG,yBAAyB;GACzB,eAAe;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;QACb,SAAS;IACb,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;GACG,yBAAyB;;AAE5B;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;;AAGA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iDAAiD;AACjD;EACE,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,kFAAkF;AAClF;EACE,WAAW;EACX,cAAc,EAAE,wEAAwE;EACxF,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB,EAAE,2CAA2C;AAClE;;AAEA;;EAEE,iBAAiB;EACjB,6BAA6B;EAC7B,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;EAEE,YAAY,EAAE,wBAAwB;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,OAAO;EACP,MAAM,EAAE,yBAAyB;EACjC,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,UAAU;AACZ;;AAEA,kDAAkD;AAClD;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;GAChB,yBAAyB;EAC1B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;GACG,yBAAyB;IACxB,cAAc;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;GACG,iBAAiB;IAChB,yBAAyB;IACzB,cAAc;AAClB;;;AAGA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,YAAY,EAAE,+BAA+B;EAC7C,SAAS;EACT,mBAAmB;EACnB,UAAU;EACV,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA,8DAA8D;AAC9D;EACE,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,iCAAiC;EACjC,4BAA4B;EAC5B,6BAA6B;EAC7B,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,UAAU;EACV,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;MACM,iBAAiB;OAChB;;AAEP;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;IACpB,sBAAsB;AAC1B;;AAEA;EACE,gBAAgB;GACf,yBAAyB;AAC5B;;;AAGA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,oBAAoB;EACpB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;GACG,4BAA4B;GAC5B,kBAAkB;GAClB,eAAe;AAClB;;AAEA;GACG,2BAA2B;GAC3B,mBAAmB;GACnB,QAAQ;GACR,iBAAiB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,wCAAwC;IACxC,gBAAgB;IAChB,gBAAgB;AACpB;;;AAGA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;AAEA;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;;AAGA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;GACG,WAAW;EACZ,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,sBAAsB;AACxB;EACE,eAAe;AACjB;AACA;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,0DAA0D;AAC1D;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;;EAEb,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;;AAExB;;AAEA;EACE,aAAa;IACX,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;GACG,iBAAiB;GACjB;;AAEH;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;IAEI,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;GACvB,iBAAiB;GACjB,YAAY;GACZ,sBAAsB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,eAAe;AACjB;;;AAGA;EACE,gBAAgB;GACf,yBAAyB;;AAE5B;AACA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,wCAAwC;AAC1C;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB,EAAE,gCAAgC;EAClD,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB,EAAE,gCAAgC;EAClD,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,eAAe,EAAE,+BAA+B;EAChD,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;;AAEtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,qDAAqD;AACrD;EACE,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,4CAA4C;EAC5C,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;IACI,eAAe;AACnB;EACE,cAAc;AAChB;IACI,sBAAsB;IACtB,sBAAsB;IACtB,wCAAwC;AAC5C;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C;EAC1C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf","sourcesContent":[".App {\n  text-align: left;\n  padding: 10px;\n  font-family: Arial, sans-serif;\n  max-width: 650px;\n  margin: 0 auto;\n}\n\n.App h1 {\n  color: #333;\n  margin-bottom: 15px;\n  text-align: center;\n  font-size: 24px;\n}\n\n.download-btn {\n  background-color: #4CAF50;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  margin-bottom: 20px;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.download-btn:hover {\n  background-color: #45a049;\n}\n.run-scheduler-container-left{\n  display: flex;\n  justify-content: start;\n  align-items: center;\n\n}\n.run-scheduler-container-right{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n.save-btn {\n  background-color: #2196F3;\n  color: white;\n  height:100%;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: bold;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  transition: all 0.3s ease;\n}\n\n.save-btn:hover {\n  background-color: #454ca0;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0,0,0,0.15);\n}\n\n\n.run-scheduler-btn {\n  background-color: #2196F3;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n    \n \n \n}\n\n.run-scheduler-btn:hover {\n  background-color: #454ca0;\n  transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.mandatory-indicator {\n  color: red;\n  margin-left: 4px;\n}\n\n.json-container {\n  background-color: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  padding: 15px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  overflow-x: auto;\n}\n\n.json-object {\n  border-left: 2px solid #2196F3;\n  padding: 10px;\n  margin: 8px 0;\n  background-color: #f8f9fa;\n  border-radius: 3px;\n}\n\n.json-key {\n  font-weight: bold;\n  color: #2196F3;\n  margin-bottom: 8px;\n  font-size: 14px;\n}\n\n.main-heading {\n  font-size: 18px;\n  margin-bottom: 15px;\n  text-align: center;\n  color: #333;\n}\n\n.json-value {\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.json-value label {\n  min-width: 120px;\n  font-weight: 500;\n  color: #555;\n  margin-right: 8px;\n  font-size: 13px;\n}\n\n.json-value input {\n  flex: 1;\n  padding: 6px 8px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  font-size: 13px;\n  min-width: 150px;\n  max-width: 250px;\n}\n\n.json-value input:only-child {\n  max-width: none;\n  width: 100%;\n}\n\n.json-value input:focus {\n  outline: none;\n  border-color: #2196F3;\n  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);\n}\n\n.json-array {\n  margin: 10px 0;\n}\n\n.json-array .json-key {\n  margin-bottom: 8px;\n}\n\n.json-array ul {\n  list-style-type: none;\n  padding-left: 0;\n}\n\n.json-array li {\n  margin-bottom: 10px;\n  padding: 8px;\n  border: 1px solid #e0e0e0;\n  border-radius: 3px;\n  background-color: #fff;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n}\n\n.json-array li:hover {\n  background-color: #f5f5f5;\n}\n\n.array-item-content {\n  width: 100%;\n  margin-bottom: 5px;\n}\n\n.add-btn, .remove-btn {\n  background-color: #2196F3;\n  color: white;\n  border: none;\n  padding: 4px 8px;\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 11px;\n  margin-left: 5px;\n  transition: background-color 0.2s;\n  align-self: flex-end;\n}\n\n.add-btn:hover, .remove-btn:hover {\n  background-color: #0b7dda;\n}\n\n.remove-btn {\n  background-color: #f44336;\n}\n\n.remove-btn:hover {\n  background-color: #d32f2f;\n}\n\n.object-field {\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.custom-layout{\n  align-items: flex-start !important;\n}\n\n.object-field .field-name {\n  min-width: 120px;\n  font-weight: 500;\n  color: #555;\n  margin-right: 8px;\n  font-size: 13px;\n}\n\n.object-field .json-value {\n  flex: 1;\n  margin-left: 0;\n  margin-bottom: 0;\n  min-width: 200px;\n}\n\n.field-name-Inclusion{\nmin-width: 120px;\n     font-weight: 600;\n    color: #444;\n  margin-right: 8px;\n  font-size: 13px;\n}\n\n.inclusions-section{\n  width: 97.5%;\n  background-color: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  padding: 12px;\n  margin-left: -5px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.field-name-exclusion{\n  min-width: 120px;\n    font-weight: 600;\n    color: #444;\n  margin-right: 5px;\n  font-size: 15px;\n  margin-left: 5px;\n}\n.nested-content {\n  margin-left: 0;\n  border-left: none;\n  padding-left: 0;\n}\n\n.section-box {\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  background-color: #f9f9f9;\n}\n\n.section-header {\n  background-color: #e9ecef;\n  padding: 10px 15px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  user-select: none;\n  border-radius: 6px 6px 0 0;\n  font-weight: 700;\n  font-size: 1.1em;\n  color: #222;\n}\n\n.section-header h3 {\n  margin: 0;\n  font-size: 1.2em;\n}\n\n.collapse-icon {\n  font-weight: bold;\n  font-size: 1.5em;\n  line-height: 1;\n}\n\n.section-content {\n  padding: 15px;\n  \n}\n\n.object-field {\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n}\n\n.primitive-field label.field-name {\n  width: 120px;\n  font-weight: 600;\n  color: #444;\n}\n\n.primitive-field label.field-name-practiceRouting {\n width: 120px;\n  font-weight: 600;   /* slightly bold like other labels */\n  font-size: 13px;    /* decrease font size */\n  color: #444;\n  margin-top: 10px;\n}\n\n.primitive-field input {\n  flex: 1;\n  padding: 6px 10px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-weight: normal;\n  color: #333;\n  background-color: #fff;\n}\n\n/* Reduce border color for time picker selects */\nselect.mr5,\nselect.mr10,\nselect.flex-grow-mr10 {\n  border-color: #c5c4c4;\n}\n\n.primitive-field input:hover {\n  background-color: #f0f0f0;\n}\n\n.primitive-field input.tooltip {\n  position: relative;\n  cursor: help;\n}\n\n.primitive-field input.tooltip::after {\n  content: \"Enter the absentee rate percentage amount ( 0 to 100 )\";\n  position: absolute;\n  bottom: 125%;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #555;\n  color: white;\n  padding: 5px 8px;\n  border-radius: 6px;\n  white-space: nowrap;\n  font-size: 12px;\n  opacity: 0;\n  visibility: hidden;\n  z-index: 1000;\n  pointer-events: none;\n  box-shadow: 0 0 6px rgba(0,0,0,0.3);\n  transition: opacity 0.3s, visibility 0.3s;\n}\n\n.primitive-field input.tooltip:hover::after {\n  opacity: 1;\n  visibility: visible;\n}\n\n.array-field {\n  margin-bottom: 15px;\n}\n\n.array-field h5 {\n  margin-bottom: 8px;\n  font-weight: 700;\n  color: #333;\n}\n\n.array-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.array-item input {\n  flex: 1;\n  padding: 6px 10px;\n  font-size: 1em;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.remove-btn {\n  margin-left: 10px;\n  background-color: #f8d7da;\n  border: 1px solid #f5c6cb;\n  color: #721c24;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9em;\n}\n\n.remove-btn:hover {\n  background-color: #c82333;\n}\n\n.add-btn {\n  margin-left: 8px;\n  background-color: #007bff;\n  border: none;\n  color: white;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9em;\n  vertical-align: middle;\n  display: inline-flex;\n  align-items: center;\n  height: 32px;\n}\n\n.add-btn:hover {\n  background-color: #0069d9;\n}\n\n.appointment-slots-container {\n  display: flex;\n  gap: 10px;\n}\n\n.appointment-slot-box {\n  flex: 1;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  padding: 10px 15px;\n  background-color: white;\n  width: 70%;\n  margin-left: -10px;\n  box-sizing: border-box;\n}\n\n.weekDay-slot-box {\n    flex: 1 1;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    padding: 10px 10px;\n    width: 175px;\n    margin-left: -6px;\n    background-color: white;\n    \n}\n\n.weekDay-slot-box h5{\n margin-top: 2px;\n  overflow-x: hidden;\n    font-weight: 700;\n    color: #222;\n}\n\n.appointment-slot-box h5 {\n  margin-top: 0;\n  margin-bottom: 10px;\n  font-weight: 700;\n  color: #222;\n}\n\n.slot-coverage-explanation {\n  font-size: 12px;\n  color: #666;\n  margin-bottom: 8px;\n  font-style: italic;\n}\n\n.daily-slot-item {\n  background-color: #ffffff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 8px 12px;\n  margin-bottom: 8px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: background-color 0.2s ease;\n}\n\n.daily-slot-item:hover {\n  background-color: #f0f0f0;\n}\n\n.daily-slot-item:last-child {\n  margin-bottom: 0;\n}\n\n.daily-slot-item-custom {\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 8px 12px;\n  margin-bottom: 8px;\n  display: flex;\n  gap: 30px;\n  align-items: center;\n  transition: background-color 0.2s ease;\n  max-width: fit-content;\n}\n\n.daily-slot-item-custom:hover {\n  background-color: #f0f0f0;\n}\n\n.daily-slot-item-custom:last-child {\n  margin-bottom: 0;\n}\n\n.weekly-slots-editor {\n  margin-bottom: 15px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n\n\n.weekly-slot-item {\n  background-color: #ffffff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 8px 12px;\n  margin-bottom: 8px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: background-color 0.2s ease;\n}\n\n.weekly-slot-item:hover {\n  background-color: #f0f0f0;\n}\n\n.weekly-slot-item:last-child {\n  margin-bottom: 0;\n}\n\n.weekly-slots-list {\n  margin-top: 12px;\n}\n\n.weekly-slots-list h6 {\n  margin-bottom: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n}\n\n/* Moved from JsonRenderer.js inline styles */\n.flex-center-mb6 {\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.flex-grow-mr10 {\n  flex-grow: 1;\n  margin-right: 10px;\n}\n\n.width80-mr10 {\n    \n    padding: 8px 12px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background-color: #fff;\n    box-sizing: border-box;\n    width: 74px;\n    margin-right: 10px;\n    text-align: center;\n}\n\n.width80-mr10:hover {\n  padding: 8px 12px;\n  background-color: #f0f0f0\n}\n\n.btn-green {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  \n}\n\n.btn-green-courseMin {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 8px;\n}\n\n.btn-green:hover {\n  background-color: #388a4b;\n  color: #d4edda;\n}\n\n.flex-center-mb10 {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.mb10{\n  border: 1px solid #e0e0e0;\n    padding: 6px 12px;\n    border-radius: 4px;\n    max-width: 532px;\n    margin-top: 16px;\n    display: inline-block;\n    vertical-align: middle;\n    width: 180%;\n    box-sizing: border-box;\n    background-color: #fff;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n\n.pre-inherit {\n  font-family: inherit;\n  font-size: inherit;\n  margin: 0;\n}\n\n.mr10 {\n  margin-right: 10px;\n}\n\n.ul-none {\n  list-style-type: none;\n  padding-left: 0;\n}\n\n.btn-red {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n  padding: 4px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.btn-red:hover {\n  background-color: #c82333;\n   color : #f8d7da;\n}\n\n.btn-red-custome-remove {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n  padding: 4px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-left: 46px;\n}\n\n.btn-red-1 {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n  padding: 4px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  margin: 12px;\n}\n\n.btn-red-1:hover{\n   background-color: #c82333;\n   color : #f8d7da;\n}\n\n.flex-center {\n  display: flex;\n  align-items: center;\n}\n\n.flex-center-WH {\n  display: flex;\n  align-items: center;\n        flex: 1 1;\n    padding: 6px 10px;\n    font-size: 14px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-weight: normal;\n    color: #333;\n    background-color: #fff;\n    gap: 5px;\n}\n\n.flex-center-WH:hover {\n   background-color: #f0f0f0;\n\n}\n.flex-end {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  width: 100%;\n}\n.flex-end-custom {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  width: 33%;\n}\n\n.flex-start {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.flex-start-custom {\n  display: flex;\n  align-items: left ;\n  width: 50%;\n}\n\n\n.capitalize {\n  text-transform: capitalize;\n}\n\n.mt20 {\n  margin-top: 20px;\n}\n\n.mr5 {\n  margin-right: 5px;\n}\n\n/* Additional styles moved from JsonRenderer.js */\n.state-label {\n  width: 120px;\n  margin-right: 10px;\n  text-transform: capitalize;\n  line-height: 24px;\n}\n\n.field-select {\n  flex-grow: 1;\n  min-width: 120px;\n  padding: 6px 8px;\n  font-size: 14px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  outline: none;\n  cursor: pointer;\n  height: 32px;\n  font-weight: normal;\n  color: #333;\n  background-color: #fff;\n}\n\n.field-select:hover {\n  background-color: #f0f0f0;\n}\n\n.field-label-block {\n  font-weight: 600;\n  margin-bottom: 8px;\n  display: block;\n}\n\n/* Courses minimum table layout: left sticky course column and scrollable months */\n.courses-min-table-wrapper {\n  width: 100%;\n  overflow: auto; /* allow horizontal scroll for months while keeping course col visible */\n  -webkit-overflow-scrolling: touch;\n}\n\n.courses-min-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed; /* predictable column widths and wrapping */\n}\n\n.courses-min-table th,\n.courses-min-table td {\n  padding: 8px 10px;\n  border-bottom: 1px solid #eee;\n  vertical-align: middle;\n  text-align: left;\n  background-clip: padding-box;\n}\n\n.courses-min-table .course-col,\n.courses-min-table .course-name-cell {\n  width: 240px; /* fixed sidebar width */\n  min-width: 200px;\n  max-width: 260px;\n  white-space: normal;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n  text-align: left;\n  padding-left: 12px;\n}\n\n/* Sticky left column */\n.courses-min-table .course-col {\n  position: sticky;\n  left: 0;\n  top: 0; /* keeps header visible */\n  z-index: 8;\n  background: #e9ecef;\n}\n.courses-min-table .course-name-cell {\n  position: sticky;\n  left: 0;\n  z-index: 4;\n  background: #fff;\n}\n\n/* Sticky month header */\n.courses-min-table thead th {\n  position: sticky;\n  top: 0;\n  background: #e9ecef;\n  z-index: 6;\n}\n\n/* Intersection cell (top-left) higher than both */\n.courses-min-table thead th.course-col {\n  z-index: 10;\n}\n\n.courses-min-table td input {\n  box-sizing: border-box;\n  width: 56px;\n  max-width: 100%;\n  padding: 6px 8px;\n  text-align: center;\n}\n\n@media (max-width: 720px) {\n  .courses-min-table .course-col,\n  .courses-min-table .course-name-cell {\n    width: 55%;\n  }\n}\n\n.mb16 {\n  margin-bottom: 16px;\n}\n\n.license-input {\n  flex-grow: 1;\n  padding: 6px 8px;\n  font-size: 14px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  text-transform: uppercase;\n  background-color: #fff;\n}\n\n.license-input:hover {\n  background-color: #f0f0f0;\n}\n\n.license-text {\n  text-transform: uppercase;\n  font-weight: 600;\n  font-size: 14px;\n  color: #333;\n}\n\n.btn-remove {\n  margin-left: 8px;\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n  border-radius: 4px;\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n.btn-remove:hover{\n  padding: 6px 12px;\n   background-color: #d32f2f;\n  color: #f8d7da;\n}\n\n.btn-add {\n  margin-left: 8px;\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n  border-radius: 4px;\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n.btn-add-practiceRouting {\n  margin-left: auto;\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n  border-radius: 4px;\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n.btn-add:hover {\n   background-color: #388a4b;\n    color: #d4edda;\n}\n\n.btn-blue {\n  margin-left: 8px;\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n  border-radius: 4px;\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n.btn-blue:hover {\n   padding: 6px 12px;\n    background-color: #388a4b;\n    color: #d4edda;\n}\n\n\n.add-select {\n  width: 165px;\n  padding: 6px 8px;\n  font-size: 14px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  background-color: #fff;\n}\n\n.add-select:hover {\n  background-color: #f0f0f0;\n}\n\n.add-select-course {\n  width: 600px;\n  padding: 6px 8px;\n  font-size: 14px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  background-color: #fff;\n}\n\n.add-select-course:hover {\n  background-color: #f0f0f0;\n}\n.section-content.collapsed {\n  display: none;\n}\n\n.section-content.expanded {\n  display: block;\n}\n\n.box-container {\n  margin-bottom: 20px;\n}\n\n/* Tooltip styles */\n.tooltip {\n  position: relative;\n  display: inline-block;\n  cursor: help;\n}\n\n.tooltip .tooltiptext {\n  visibility: hidden;\n  width: 260px;\n  background-color: #555;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 8px;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%; /* Position above the element */\n  left: 50%;\n  margin-left: -130px;\n  opacity: 0;\n  transition: opacity 0.3s;\n  font-size: 12px;\n}\n\n.tooltip:hover .tooltiptext {\n  visibility: visible;\n  opacity: 1;\n}\n\n/* Fix for courses list to display vertically with box model */\n.courses-list > div {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: flex-start !important;\n  margin-bottom: 8px !important;\n  width: 100% !important;\n}\n\n.courses-list > div > div {\n  display: flex !important;\n  justify-content: flex-start !important;\n  align-items: center !important;\n  margin-bottom: 8px !important;\n  border: 1px solid #ccc !important;\n  padding: 6px 12px !important;\n  border-radius: 4px !important;\n  width: 100% !important;\n  gap: 8px !important;\n  flex-wrap: nowrap !important;\n}\n\n.courses-list > div > div > .course-item {\n  margin-left: auto !important;\n  max-width: 150px !important;\n  box-sizing: border-box !important;\n}\n\n.courses-list.box-container {\n  border: 1px solid #ccc;\n  padding: 6px 12px;\n  border-radius: 4px;\n  max-width: 320px;\n  margin-bottom: 16px;\n  display: inline-block;\n  vertical-align: middle;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.course-item {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.btn-remove {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n  border-radius: 4px;\n  padding: 2px 8px;\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 1;\n  height: 22px;\n  vertical-align: middle;\n  margin-left: 8px;\n}\n\n/* New styles for updated courses rendering */\n.courses-container {\n  width: 95%;\n  margin-top: 8px;\n  background-color: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  padding: 15px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.course-items {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.course-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: #fff;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.course-item:hover{\n      padding: 8px 12px;\n       background-color:#f0f0f0\n\n}\n\n.course-item span {\n  flex-grow: 1;\n  font-size: 14px;\n  color: #333;\n  overflow-wrap: break-word;\n}\n\n.course-item button {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n  border-radius: 4px;\n  padding: 4px 8px;\n  cursor: pointer;\n  font-size: 12px;\n  height: 24px;\n  min-width: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.course-item button:hover {\n  background-color: #c82333;\n}\n\n.existing-items {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: flex-start;\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.license-item {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  background-color: #fff;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n    box-sizing: border-box;\n}\n\n.license-item:hover{\n  padding: 4px 8px;\n   background-color: #f0f0f0;\n} \n\n\n.license-item .license-text {\n  font-weight: normal;\n  color: #333;\n}\n\n.remove-provider-btn{\n  margin-top: 14px;\n}\n\n\n.license-item .btn-remove {\n  margin-left: 0;\n  padding: 2px 6px;\n  font-size: 16px;\n  line-height: 1;\n  height: auto;\n  min-width: auto;\n}\n\n.primitive-field .field-value {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.license-value-area {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex: 1;\n  min-width: 0;\n  border: 1px solid #e0e0e0;\n  padding: 6px 12px;\n  border-radius: 4px;\n  max-width: 532px;\n  display: flex;\n  box-sizing: border-box;\n  background-color: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.practiceRouting-value-area {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex: 1;\n  min-width: 0;\n  border: 1px solid #e0e0e0;\n  padding: 6px 12px;\n  border-radius: 4px;\n  max-width: 532px;\n  display: flex;\n  box-sizing: border-box;\n  background-color: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-top: 10px;\n}\n\n.add-section-box {\n  border: 1px solid #ccc;\n  padding: 8px 12px;\n  border-radius: 4px;\n  background-color: #fff;\n  box-sizing: border-box;\n}\n\n.license-value-column {\n  flex-direction: column !important;\n  gap: 10px;\n}\n\n.existing-items-license {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 10px;\n  justify-items: start;\n  width: 100%;\n  margin-bottom: 0;\n}\n\n.add-section.flex-center {\n  margin-left: auto;\n  margin-bottom: 0;\n}\n\n.add-section.flex-start {\n   justify-content: flex-start ;\n   padding-left: 0px ;\n   margin-left: 0 ;\n}\n\n.add-section-credential {\n   justify-content: flex-start;\n   align-items: center;\n   gap: 5px;\n   margin-top: -10px;\n}\n\n/* History section styles */\n.history-section {\n  margin-top: 30px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background-color: #f9f9f9;\n}\n\n.history-section .section-header {\n  background-color: #e9ecef;\n  padding: 10px 15px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  user-select: none;\n  border-radius: 6px 6px 0 0;\n  font-weight: 700;\n  font-size: 1.1em;\n  color: #222;\n}\n\n.history-section .section-header h2 {\n  margin: 0;\n  font-size: 1.2em;\n}\n\n.history-section .collapse-icon {\n  font-weight: bold;\n  font-size: 1.5em;\n  line-height: 1;\n}\n\n.history-content {\n  padding: 15px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.history-item {\n  margin-bottom: 20px;\n  padding: 10px;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  background-color: #fff;\n}\n\n.history-item p {\n  margin: 0 0 10px 0;\n  font-size: 14px;\n  color: #666;\n}\n\n.history-item pre {\n  background-color: #f8f8f8;\n  padding: 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  overflow-x: auto;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n.output-files-section {\n    background-color: #fff;\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    padding: 15px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    overflow-x: auto;\n    margin-top: 20px;\n}\n\n\n.output-files-section h2 {\n  margin-top: 0;\n  font-size: 20px;\n  color: #222;\n  margin-bottom: 15px;\n}\n\n.output-files-section ul {\n  list-style-type: none;\n  padding-left: 0;\n}\n\n.output-files-section li {\n\n}\n\n.output-files-section a {\n  color: #2196F3;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.output-files-section a:hover {\n  text-decoration: underline;\n}\n\n.output-files-section .section-header h2 {\n  margin: 0;\n  font-size: 1.2em;\n}\n\n.output-files-section li {\n  cursor: pointer;\n}\n.link-btn {\n  background: none;\n  border: none;\n  color: #2196F3;\n  text-decoration: none;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 0;\n  font-family: inherit;\n}\n\n.link-btn:hover {\n  text-decoration: underline;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n\n.changed-field {\n  background-color: transparent;\n  border-color: inherit;\n}\n\n.field-value-display {\n  font-size: 14px;\n  font-weight: normal;\n  color: #333;\n  margin-left: 8px;\n}\n\n.field-value-display strong {\n  font-weight: bold;\n}\n\n/* DatePicker styling */\n.react-datepicker-wrapper {\n  flex: 1;\n  display: inline-block;\n}\n\n.react-datepicker__input-container input {\n  width: 100%;\n  padding: 6px 10px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-weight: normal;\n  color: #333;\n  background-color: #fff;\n  box-sizing: border-box;\n}\n\n.react-datepicker__input-container-exclusion {\n   width: 100%;\n  padding: 6px 10px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-weight: normal;\n  color: #333;\n  background-color: #fff;\n  box-sizing: border-box;\n.react-datepicker {\n  font-size: 14px;\n}\n}\n\n.react-datepicker__header {\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__day--selected {\n  background-color: #007bff;\n  color: white;\n}\n\n/* Specific styling for DatePicker in exclusions section */\n.exclusions-section .react-datepicker-wrapper {\n  width: 90%;\n}\n\n.exclusions-section .react-datepicker__input-container input {\n  width: 95%;\n}\n\n.availability-editor .weekday-inclusions .flex-center-mb6 span {\n  font-weight: normal;\n  color: #333;\n}\n.weekday-inclusions{\n  width: 90%;\n  margin-top: 10px;\n  background-color: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  padding: 15px;\n\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.weekday-inclusions h4 {\n  margin-top: -10px;\n  margin-bottom: -10px;\n  padding: 8px 12px;\n  background-color: #fff;\n\n}\n\n.working-hours-edit {\n  display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    margin-top: -20px;\n    margin-left: 115px;\n}\n\n.courses-display {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 10px;\n}\n\n.course-display {\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  background-color: #ffffff;\n  font-size: 14px;\n  font-weight: normal;\n  color: #333;\n}\n\n.course-display:hover{\n   padding: 8px 12px;\n   background-color: #f0f0f0\n\n}\n\n.notification {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  padding: 15px 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-width: 300px;\n  max-width: 500px;\n  font-family: Arial, sans-serif;\n  font-size: 14px;\n}\n\n.notification.success {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.notification.error {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.notification-close {\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: inherit;\n  margin-left: 10px;\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.notification-close:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n}\n\n/* Scheduler error notification styles */\n.notification.error span a {\n  color: #007bff !important;\n  text-decoration: underline !important;\n  margin-left: 5px !important;\n}\n\n.notification.error span a:hover {\n  color: #0056b3 !important;\n  text-decoration: none !important;\n}\n\n.month-dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n}\n\n.month-dialog {\n  background-color: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  max-width: 400px;\n  width: 90%;\n  font-family: Arial, sans-serif;\n}\n\n.month-dialog h3 {\n  margin-top: 0;\n  margin-bottom: 15px;\n  color: #333;\n  font-size: 18px;\n}\n\n.month-dialog select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.month-dialog select:focus {\n  outline: none;\n  border-color: #2196F3;\n  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);\n}\n\n.dialog-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.dialog-buttons button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.dialog-buttons button:first-child {\n  background-color: #2196F3;\n  color: white;\n}\n\n.dialog-buttons button:first-child:hover {\n  background-color: #0b7dda;\n}\n\n.dialog-buttons button:last-child {\n  background-color: #6c757d;\n  color: white;\n}\n\n.dialog-buttons button:last-child:hover {\n  background-color: #5a6268;\n}\n\n.select-course-name{\n\n    justify-content: space-between;\n    align-items: center;\n    border-radius: 4px;\n    background-color: #fff;\n    box-sizing: border-box;\n   padding: 8px 12px;\n   width: 71.7%;\n   border: 1px solid #ccc;\n}\n\n.day-select {\n  width: 120px;\n  padding: 6px 8px;\n  font-size: 14px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  background-color: #fff;\n  outline: none;\n  cursor: pointer;\n}\n\n\n.day-select:hover{\n  padding: 6px 8px;\n   background-color: #f0f0f0;\n\n}\n.select-course-name:hover{\n  padding: 8px 12px;\n  background-color: #f0f0f0;\n}\n\n.courses-min-editor{\n  border: 1px solid #e0e0e0;\n  padding: 6px 12px;\n  border-radius: 4px;\n  max-width: 100%;\n  margin-bottom: 16px;\n  display: block;\n  vertical-align: middle;\n  width: 100%;\n  box-sizing: border-box;\n  background-color: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n.courses-min-table-wrapper{\n  margin-top: 8px;\n}\n.courses-min-table-scroll{\n  overflow-x: auto;\n}\n.courses-min-table{\n  border-collapse: collapse;\n  width: 100%;\n  font-size: 14px;\n  table-layout: fixed;\n}\n.courses-min-table th{\n  text-align: left;\n  font-size: 14px;\n  font-weight: 600; /* match practice label weight */\n  padding: 8px 10px;\n  color: #444;\n  background: #e9ecef;\n}\n.courses-min-table td{\n  padding: 8px 10px;\n}\n.courses-min-table .course-name-cell{\n  font-weight: 600; /* match practice label weight */\n  white-space: normal;\n  padding-right: 14px;\n  color: #444;\n  overflow-wrap: anywhere;\n}\n.courses-min-table input{\n  width: 56px;\n  font-size: 14px; /* align with practice inputs */\n  font-weight: normal;\n  text-align: center;\n  padding: 6px 8px;\n}\n/* Footer styles */\n.footer {\n  text-align: center;\n  padding: 20px 0;\n  font-family: Arial, sans-serif;\n  font-size: 0.9rem;\n  border-top: 1px solid #d8d8d8;\n  margin-top: 40px;\n}\n\n.footer-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 15px;\n}\n\n.footer-logo {\n  height: 30px;\n}\n\n.copyright {\n  margin: 0;\n  color: #333;\n}\n\n/* File Groups Styles */\n.file-groups {\n  margin-top: 10px;\n}\n\n.file-group {\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  margin-bottom: 15px;\n  background-color: #fafafa;\n}\n\n.file-group-header {\n  padding: 12px 15px;\n  background-color: #f0f0f0;\n  border-bottom: 1px solid #e0e0e0;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 6px 6px 0 0;\n}\n\n.file-group-header h3 {\n  margin: 0;\n  font-size: 16px;\n  color: #333;\n  font-weight: 600;\n}\n\n.file-group-content {\n  padding: 15px;\n}\n\n.file-group-content.collapsed {\n  display: none;\n}\n\n.file-group-content.expanded {\n  display: block;\n}\n\n.file-group-content ul {\n  list-style-type: none;\n  padding-left: 0;\n  margin: 0;\n}\n\n.file-group-content li {\n  padding: 8px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.file-group-content li:last-child {\n  border-bottom: none;\n}\n\n.file-group-content a {\n  color: #2196f3;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.file-group-content a:hover {\n  text-decoration: underline;\n}\n\n/* Navbar styles */\n.navbar {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0.5rem 2rem;\n \n}\n\n.logo-box {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.logo-img {\n  height: 40px;\n}\n\n.best-text {\n  font-weight: 700;\n  font-size: '1.5rem';\n  color: '#0e2a71';\n}\n\n.title {\n  justify-self: center;\n  font-weight: 700;\n  font-size: 1.8rem;\n  color: #0e2a71;\n}\n\n.actions {\n  justify-self: end;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n/* Fixed button styles with EXACT consistent sizing */\n.button-base {\n  padding: 0.5rem 1rem;\n  border-radius: 5px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  min-width: 80px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 36px;\n  box-sizing: border-box;\n  line-height: 1;\n}\n\n.profile-btn {\n  background: transparent;\n  color: #0e2a71;\n  border: 1px solid #0e2a71;\n}\n\n.profile-btn:hover {\n  background-color: #f0f0f0;\n}\n\n.logout-btn {\n  background: #0e2a71;\n  color: white;\n  border: 1px solid #0e2a71;\n}\n\n.logout-btn:hover {\n  background-color: #454ca0;\n}\n\n.dropdown-container {\n  position: relative;\n}\n\n.dropdown-content {\n  display: none;\n  position: absolute;\n  right: 0;\n  top: 45px;\n  background-color: white;\n  min-width: 250px;\n  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.1);\n  z-index: 1;\n  border-radius: 5px;\n  border: 1px solid #eee;\n  padding: 12px 16px;\n}\n    max-width: 100%;\n.dropdown-content.show {\n  display: block;\n}\n    box-sizing: border-box;\n    background-color: #fff;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n.info-p {\n  margin: 5px 0;\n  font-size: 14px;\n}\n\n.dropdown-hr {\n  border: 0;\n  border-top: 1px solid #eee;\n  margin: 8px 0;\n}\n\n.roles-p {\n  margin: 5px 0;\n  font-size: 14px;\n  text-transform: capitalize;\n}\n\n.scheduler-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 3000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
